class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapProductId = this.dataset.giftWrapId;
    this.isGiftWrappingEnabled = this.dataset.giftWrapping;
    this.cartItemCount = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapItemCount = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.totalItemCount = parseInt(this.getAttribute('items-in-cart'));
    this.giftWrapMode = this.dataset.giftWrappingLimit;
    this.attributeName = this.dataset.attribute;
  }

  connectedCallback() {
    console.log("Connected", this.dataset.attribute);
    this.initializeGiftWrapCheckbox();
    // this.handleInitialGiftWrapState();
    console.log({
      attribute: this.dataset.attribute,
      cartItemCount: this.cartItemCount,
      giftWrapItemCount: this.giftWrapItemCount,
      totalItemCount: this.totalItemCount,
      enabled: this.isGiftWrappingEnabled
    });
  }

initializeGiftWrapCheckbox() {
  this.querySelectorAll(`[name="attributes[${this.attributeName}]"]`).forEach((checkbox) => {
    checkbox.addEventListener('change', (event) => {
      this.giftWrapProductId = event.target.dataset.variantId;

      const wrapper = event.target.closest('.sample_product-checkbox');

      if (event.target.checked) {
        wrapper?.classList.add('loader');
        this.addGiftWrap();
      } else {
        wrapper?.classList.add('loader');
        this.removeGiftWrap();
      }
    });
  });
}

  handleInitialGiftWrapState() {
    if (this.cartItemCount == 1 && this.giftWrapItemCount > 0) {
      return this.removeGiftWrap();
    }
    if (this.giftWrapItemCount > 0 && this.isGiftWrappingEnabled.length == 0) {
      return this.addGiftWrap();
    }
    if (this.giftWrapItemCount == 0 && this.isGiftWrappingEnabled.length > 0) {
      return this.addGiftWrap();
    }
  }

  addGiftWrap() {
    console.log("ADD", this.dataset.attribute);
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();

    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 1,
      },
      { [this.attributeName]: true },
      sectionsToUpdate
    );

    console.log({
      attribute: this.attributeName,
      productId: this.giftWrapProductId,
      body: requestBody
    });
    this.updateCart(requestBody);
  }

  removeGiftWrap() {
     console.log("REMOVE", this.dataset.attribute);
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 0,
      },
      { [this.attributeName]: '', 'gift-note': '' },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  createRequestBody(updates, attributes, sections) {
    return JSON.stringify({ updates, attributes, sections });
  }

  updateCart(body) {
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }

  showLoader() {
    const loaderElement = this.querySelector('.loader');
    if (loaderElement) loaderElement.classList.add('btn--loading');
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.updateGiftNote.bind(this), 300));
  }

  updateGiftNote(event) {
    const requestBody = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body: requestBody } });
  }
}
customElements.define('gift-note', GiftNote);

class RemoveGiftWrapButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItemsElement = this.closest('cart-items');
      cartItemsElement.showLoader(this.dataset.index);

      // const giftWrappingElement = document.querySelector('gift-wrapping');
      const giftWrappingElement = this.closest('gift-wrapping');
      giftWrappingElement.removeGiftWrap();
    });
  }
}
customElements.define('gift-wrap-remove-item', RemoveGiftWrapButton, { extends: 'a' });
